import { render, staticRenderFns } from "./ComprasUpdate.vue?vue&type=template&id=70ff18ec&"
import script from "./ComprasUpdate.vue?vue&type=script&lang=js&"
export * from "./ComprasUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports